import createReducer from "../createReducer";
import { hubspotHandlers } from "./handlers";

import { IHubspotStatusState } from "./types";

export const hubspotStatus: IHubspotStatusState = {
    status: null,
    message: null,
    success: null,
};

export default createReducer(hubspotStatus, hubspotHandlers);
